<div class="application md-whiteframe-2dp">
  <div class="app-drawer" #drawer>
    <ng-content></ng-content>
  </div>
</div>
